import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { convertJsonToFormData, mapFormData } from 'helpers/formData';

export interface MotivationCentreImagesPostOptions {
  image: File;
}

export function clientMotivationCentreImagesApi(path: string) {
  return {
    path,
    POST: (params: MotivationCentreImagesPostOptions) =>
      api.post<JsonApiResponseSingle>(
        path,
        convertJsonToFormData({
          data: {
            attributes: mapFormData(params),
          },
        })
      ),
  };
}
